import { AbstractModel } from '@uzurv/core';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RiderRidePreferences extends AbstractModel {
  @autoserialize
  riderId: number;

  @autoserialize
  audioRecordingOptedIn: boolean;
}
